var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomiconDocumentation = function SvgCustomiconDocumentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customicon-documentation_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "customicon-documentation_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0v20h20V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#customicon-documentation_svg__b)",
    fill: "#5457FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.615 16.156h-2.1c-.98 0-1.78-.8-1.78-1.78V2.42c0-.98.8-1.78 1.78-1.78h9.82c.98 0 1.78.8 1.78 1.78v1.92h-1V2.42c0-.43-.35-.78-.78-.78H3.52c-.43 0-.78.35-.78.78v11.955c0 .43.35.78.78.78h2.1v1h-.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.48 3.84H6.66c-.98 0-1.78.8-1.78 1.78v11.955c0 .98.8 1.78 1.78 1.78h9.82c.98 0 1.78-.8 1.78-1.78V5.625c0-.98-.8-1.78-1.78-1.78V3.84Zm.78 13.735c0 .43-.35.78-.78.78H6.66c-.43 0-.78-.35-.78-.78V5.625c0-.43.35-.78.78-.78h9.82c.43 0 .78.35.78.78V17.58v-.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.666 14.42h-6.19a.501.501 0 0 1-.5-.5c0-.275.225-.5.5-.5h6.19c.275 0 .5.225.5.5s-.225.5-.5.5ZM14.666 12.1h-6.19a.501.501 0 0 1-.5-.5c0-.275.225-.5.5-.5h6.19c.275 0 .5.225.5.5s-.225.5-.5.5ZM14.666 9.785h-6.19a.501.501 0 0 1-.5-.5c0-.275.225-.5.5-.5h6.19c.275 0 .5.225.5.5s-.225.5-.5.5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "customicon-documentation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCustomiconDocumentation;